/* eslint-disable */
import { Grid, InputLabel, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_DRIVER_INSTRUCTIONS_BLUR, UI_DRIVER_INSTRUCTIONS_FOCUS } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * DriverInstructions
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DriverInstructions = ({ actions, classes, driverInstructionsContent, onChange, disabled, isEdit, originalValue, mandatoryFieldError, isRequired }) => {
  const helperText = `Max 272 characters. This text will be printed on the delivery docket.`;
  const [tooMany, setTooMany] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  const [originalContent, setOriginalContent] = useState(driverInstructionsContent);
  const [updatedContent, setUpdatedContent] = useState(``);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEdit) {
      if (typeof originalValue !== 'undefined') {
        setOriginalContent(originalValue)
        if (originalValue !== driverInstructionsContent) {
          setIsTouched(true)
        }
      }
    }
  }, []);

  useEffect(() => {
    if(isRequired && !updatedContent && (!originalContent || !originalContent.length)) {
      onChange({ isValid: false, selectedDriverInstructions: updatedContent || originalContent, isTouched });
    } else if (isRequired) {
      onChange({ isValid: (originalContent && originalContent.length <= 272) || updatedContent.length <= 272, selectedDriverInstructions: (updatedContent || originalContent), isTouched });
    } else {
      onChange({ isValid: (updatedContent || originalContent) ? (updatedContent || originalContent).length <= 272 : true, selectedDriverInstructions: (updatedContent || originalContent), isTouched });
    }
  }, [isRequired]);

  /**
   * Updates helper text
   * @param {number} value Number of characters typedin
   * @returns {void} void
   */
  const updateHelperText = (value) => {
    setTooMany(value.length > 272);
    setIsTouched(true);
    setUpdatedContent(value);

    if(isRequired && (!value || !value.length)) {
      onChange({ isValid: false, selectedDriverInstructions: value, isTouched });
    } else if (isRequired) {
      onChange({ isValid: value.length <= 272, selectedDriverInstructions: value, isTouched });
    } else {
      onChange({ isValid: value ? value.length <= 272 : true, selectedDriverInstructions: value, isTouched });
    }
    return;
  };

  /**
   * Used to report to analytics
   * @returns {void} void
   */
  const onBlurHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `driverInstructionsBlur`,
        },
      },
      type: UI_DRIVER_INSTRUCTIONS_BLUR,
    });
    return;
  };

  /**
   * Used to report to analytics
   * @returns {void} void
   */
  const onFocusHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `driverInstructionsFocus`,
        },
      },
      type: UI_DRIVER_INSTRUCTIONS_FOCUS,
    });
    return;
  };

  let fieldClass = null;
  if (isEdit) {
    fieldClass = originalContent === driverInstructionsContent || !isTouched ? classes.editableField : classes.touchedField;
  }

  return (
    <Grid container spacing={2} className={cn(classes.flexWrapNowrap)}>
      <Grid item xs={12}>
        <InputLabel className={cn(mandatoryFieldError ? classes.mandatoryFieldError : null, classes.inputLabel)}>Driver Instructions {!isRequired && `(Optional)`}</InputLabel>
        <TextField
          error={mandatoryFieldError}
          fullWidth
          disabled={disabled}
          InputProps={{
            className: fieldClass,
          }}
          size="medium"
          rows="5"
          rowsMax="8"
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          multiline
          inputRef={inputRef}
          onChange={(e) => updateHelperText(e.currentTarget.value)}
          placeholder="Type any special instructions for the driver, e.g. Street number, closest cross street, safety information, onsite directions, radio frequency, etc..."
          value={driverInstructionsContent || ``}
          helperText={helperText}
          error={tooMany || mandatoryFieldError}
        />
      </Grid>
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
DriverInstructions.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  driverInstructionsContent: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isEdit: PropTypes.bool,
};

export default compose(
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(DriverInstructions);
